__turbopack_context__.v({
  "hidden": "fsRjoW_hidden",
  "prompt": "fsRjoW_prompt",
  "rightCircle": "fsRjoW_rightCircle",
});
